import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import MetaTags from "react-meta-tags"
import axios from "axios"
import {API_URL, sitename} from "constants/constants"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

import {
    Button,
    Card,
    Form,
    CardBody,
    Col,
    Container,
    Row,
    Input,
    CardTitle,
    Label, Modal, CardText,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"

//redux
import { useSelector, useDispatch } from "react-redux"
import { DateRangeCard } from "pages/EndUsers/Common/DateRangeCard"
import {collectSendBonus, depositEndUserCash, getEndUser} from "helpers/repository"
import { withdrawalEndUserCash } from "helpers/repository"
import TableLoader from "../../../components/Common/TableLoader";
import {LargeModal} from "../../../components/Common/LargeModal";
import {ReasonModal} from "../ReasonModal";

const EndUserAccounts = props => {
    const dispatch = useDispatch()
    const [data, setData] = useState([])
    const [transactionData, setTransactionData] = useState([])
    const [amount, setAmount] = useState(null)
    const [loadingMessage, setLoadingMessage] = useState("1");
    const [transactionLoadingMessage, setTransactionLoadingMessage] = useState("1");
    const [isModalOpen, setModalOpen] = useState(false);
    const [functionName, setFunctionName] = useState("");
    const [searchUserId, setSearchUserId] = useState("null")
    const [reason, setReason] = useState(null)
    const [id, setId] = useState(null)
    const getAmountValue = () => {
        return amount
    }
    const selectRow = {
        mode: "checkbox",
        hideSelectAll: true,
    }
    const getData = () => {
        setLoadingMessage("1");
        axios({
            method: "get",
            url: `${API_URL}/admin/get-end-users?search=${searchUserId}`,
        })
            .then(function (response) {
                setData(response?.data?.data)
                setLoadingMessage("0");
            })
            .catch(function (response) {})
    };

    const callModalFunction = (fname,val,id) => {
        if(val){
            setModalOpen(true)
            setFunctionName(fname)
            setId(id)
        }
        else{
            toastr.error("Please enter amount !!!")
        }

    }
    useEffect(() => {
        getData();
    }, [])

    const searchAll = () => {
        setLoadingMessage("1");
        axios({
            method: "get",
            url: `${API_URL}/admin/get-end-users?search=all`,
        })
            .then(function (response) {
                setData(response?.data?.data)
                setLoadingMessage("0");
            })
            .catch(function (response) {})
    }

    const showTransaction = (id) => {
        setTransactionLoadingMessage("1");
        axios({
            method: "get",
            url: `${API_URL}/admin/get-end-users/${id}/get-transaction`,
        })
            .then(function (response) {
                setTransactionData(response?.data)
                setTransactionLoadingMessage("0");
            })
            .catch(function (response) {})
    }

    const [modal, setModal] = useState(false)
    const [modal1, setModal1] = useState(false)
    const [orderList, setOrderList] = useState([])
    const [isEdit, setIsEdit] = useState(false)

    const { SearchBar } = Search

    const toggleViewModal = () => setModal1(!modal1)

    const deposit = () => {
        try {
            var loggedInUser=JSON.parse(localStorage.getItem("user"))?.user?.id;
            depositEndUserCash(id,loggedInUser, { amount: amount, reason: reason })
                .then(res => {
                    toastr.success(res?.data?.message)
                    setModalOpen(false)
                    setAmount(null);
                    setReason(null);
                    // $('#'+idElement).val('')
                    getData();
                })
                .catch(error => {
                    toastr.error(error?.response?.data?.message)
                })
        } catch (error) {
            toastr.error("Error connecting server")
        }
    }

    const saveNoteWithAmount = (fname) => {
        if(fname=='deposit'){
            deposit()
        }
        else if(fname=='withdraw'){
            withdrawal()
        }
        else if (fname=='collectBonus'){
            collectBonus()
        }
        else if (fname=='collectCash'){
            collectCash()
        }
    }

    const collectBonus = () => {
        try {
            var loggedInUser=JSON.parse(localStorage.getItem("user"))?.user?.id;

            collectSendBonus(id,loggedInUser, { amount: amount, reason: reason  },'collect')
                .then(res => {
                    toastr.success(res?.data?.message)
                    setModalOpen(false)
                    setAmount(null);
                    setReason(null);
                    getData();
                })
                .catch(error => {
                    toastr.error(error?.response?.data?.message)
                })
        } catch (error) {
            toastr.error("Error connecting server")
        }
    }
    const collectCash = () => {
        try {
            var loggedInUser=JSON.parse(localStorage.getItem("user"))?.user?.id;
            collectSendBonus(id,loggedInUser, { amount: amount, reason: reason },'send')
                .then(res => {
                    toastr.success(res?.data?.message)
                    setModalOpen(false)
                    setAmount(null);
                    setReason(null);
                    getData();
                })
                .catch(error => {
                    toastr.error(error?.response?.data?.message)
                })
        } catch (error) {
            toastr.error("Error connecting server")
        }
    }

    const withdrawal = () => {
        try {
            var loggedInUser=JSON.parse(localStorage.getItem("user"))?.user?.id;
            withdrawalEndUserCash(id,loggedInUser, { amount: amount, reason: reason })
                .then(res => {
                    toastr.success(res?.data?.message)
                    setModalOpen(false)
                    setAmount(null);
                    setReason(null);
                    getData();
                })
                .catch(error => {
                    toastr.error(error?.response?.data?.message)
                })
        } catch (error) {
            toastr.error("Error connecting server")
        }
    }

    const columns = [
        {
            dataField: "id",
            text: "Id",
            sort: true,
        },
        {
            dataField: "phone_number",
            text: "User Name",
            sort: true,
            formatter: (cellContent, row) => {
                return <>{`${row?.phone_number ?? ""}`}</>
            },
        },
        {
            dataField: "cash_balance",
            text: "Cash Balance",
            sort: true,
        },
        {
            dataField: "bonus_balance",
            text: "Bonus Balance",
            sort: true,
        },
        {
            dataField: "Status",
            text: "Status",
            sort: true,
            formatter: (cellContent, row) => {
                return <>{`${row?.user_status ? "Active" : 'In-Active'}`}</>
            },
        },
        {
            dataField: "MoneyTransfer",
            text: "MoneyTransfer",
            sort: true,

            formatter: (cellContent, row) => (
                <React.Fragment>
                    <Row className="mb-4">
                        <Col lg={10}>
                            <div className="input-group">
                                <Input
                                    type="text"
                                    name="amt"
                                    className="form-control"
                                    id={`inputGroupSendMoney${row.id}`}
                                    aria-describedby="inputGroupSendMoney"
                                    placeholder="Send Money"
                                    onChange={e => {
                                        setAmount(e.target.value)
                                    }}
                                    required={true}
                                    value={amount}
                                />
                                <button
                                    className="btn btn-success"
                                    type="button"
                                    id="inputGroupSendMoney"
                                    onClick={(event) => {
                                        callModalFunction("deposit",$(`#inputGroupSendMoney${row.id}`).val(),row?.id)
                                        // deposit(row?.id, $(`#inputGroupSendMoney${row.id}`).val(),`inputGroupSendMoney${row.id}`)
                                    }}
                                >
                                    Send Cash
                                </button>
                            </div>
                        </Col>

                        {/* <Col lg={2}></Col> */}

                        {/* <Col lg={2}></Col> */}
                    </Row>
                    <Row className="mb-4">
                        {(row.cash_balance && row.cash_balance!=0)?
                            <Col lg={10}>
                                <div className="input-group">
                                    <Input
                                        type="text"
                                        className="form-control"
                                        id={`inputGroupCollectMoney${row.id}`}
                                        aria-describedby="inputGroupCollectMoney"
                                        placeholder="Collect Money"
                                        onChange={e => {
                                            setAmount(e.target.value)
                                        }}
                                        // value={amount}
                                    />
                                    <button
                                        type="submit"
                                        className="btn btn-danger"
                                        id="inputGroupCollectMoney"
                                        onClick={() => {
                                            callModalFunction("withdraw",$(`#inputGroupCollectMoney${row.id}`).val(),row?.id)
                                            // withdrawal(row?.id, $(`#inputGroupCollectMoney${row.id}`).val(),`inputGroupCollectMoney${row.id}`)
                                        }}
                                    >
                                        Collect Cash
                                    </button>
                                </div>
                            </Col> : ''
                        }
                    </Row>

                    <Row>

                    </Row>
                </React.Fragment>
            ),
        },
        {
            dataField: "BonusTransfer",
            text: "BonusTransfer",
            sort: true,

            formatter: (cellContent, row) => (
                <React.Fragment>
                    <Row className="mb-4">
                        <Col lg={10}>
                            <div className="input-group">
                                <Input
                                    type="text"
                                    className="form-control"
                                    id={`inputGroupSendBonus${row.id}`}
                                    aria-describedby="inputGroupSendBonus"
                                    placeholder="Send Bonus"
                                    onChange={e => {
                                        setAmount(e.target.value)
                                    }}
                                    // value={amount}
                                />
                                <button
                                    className="btn btn-danger"
                                    type="button"
                                    id="inputGroupSendBonus"
                                    onClick={(event) => {
                                        callModalFunction("collectCash",$(`#inputGroupSendBonus${row.id}`).val(),row?.id)
                                        // collectCash(row?.id, $(`#inputGroupSendBonus${row.id}`).val(),`inputGroupSendBonus${row.id}`)
                                    }}
                                >
                                    Send Bonus
                                </button>
                            </div>
                        </Col>

                    </Row>
                    <Row className="mb-4">
                        <Col lg={10}>
                            <div className="input-group">
                                <Input
                                    type="text"
                                    className="form-control"
                                    id={`inputGroupCollectBonus${row.id}`}
                                    aria-describedby="inputGroupCollectBonus"
                                    placeholder="Collect Bonus"
                                    onChange={e => {
                                        setAmount(e.target.value)
                                    }}
                                    // value={amount}
                                />
                                <button
                                    type="submit"
                                    className="btn btn-danger"
                                    id="inputGroupCollectBonus"
                                    onClick={() => {
                                        callModalFunction("collectBonus",$(`#inputGroupCollectBonus${row.id}`).val(),row?.id)
                                        // collectBonus(row?.id, $(`#inputGroupCollectBonus${row.id}`).val(),`inputGroupCollectBonus${row.id}`)
                                    }}
                                >
                                    Collect Bonus
                                </button>
                            </div>
                        </Col>
                    </Row>
                    <Row>

                    </Row>
                </React.Fragment>
            ),
        },
        // {
        //     dataField: "Reconciliation",
        //     text: "Reconciliation",
        //     sort: true,
        //
        //     formatter: (cellContent, row) => (
        //         <React.Fragment>
        //             <Row className="mb-4">
        //                 <Col lg={10}>
        //                     <button
        //                         className="btn btn-primary"
        //                         type="button"
        //                         onClick={(event) => {
        //                             showTransaction(row?.id)
        //                         }}
        //                     >
        //                         Transactions
        //                     </button>
        //                 </Col>
        //             </Row>
        //         </React.Fragment>
        //     ),
        // },
    ]

    const transactionColumns = [
      {
        dataField: "amount",
        text: "Amount",
        sort: true,
      },
      {
        dataField: "credit_or_debit",
        text: "Credit/Debit",
        sort: true,
      },
      {
        dataField: "cash_balance",
        text: "Cash Balance",
        sort: true,
        formatter: (cell, row) => (
          <>
            {Number(
              parseFloat(row.cash_balance ?? 0)?.toFixed(2)
            ).toLocaleString("en-GB")}
          </>
        ),
      },
      {
        dataField: "bonus_balance",
        text: "Bonus Balance",
        sort: true,
        formatter: (cell, row) => (
          <>
            {Number(
              parseFloat(row.bonus_balance ?? 0)?.toFixed(2)
            ).toLocaleString("en-GB")}
          </>
        ),
      },
      {
        dataField: "type",
        text: "Type",
        sort: true,
      },
      {
        dataField: "ticket_id",
        text: "TicketID",
        sort: true,
      },
      {
        dataField: "event",
        text: "Event",
        sort: true,
      },
      {
        dataField: "date",
        text: "Date",
        sort: true,
        formatter: (cell, row) => {
          const date = new Date(row?.date)
          const formattedDate = date.toLocaleString("en-GB", {
            timeZone: "CAT",
            hour12: true,
          })
          const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
            match.toUpperCase()
          )
          return <>{capitalizedDate}</>
        },
      },
    ]

    const defaultSorted = [
        {
            dataField: "orderId",
            order: "desc",
        },
    ]
    const defaulTransactiontSorted = [
        {
            dataField: "date",
            order: "desc",
        },
    ]

    //pagination customization
    const pageOptions = {
        sizePerPage: 6,
        totalSize: data.length,
        custom: true,
    }
    const pageTransactionOptions = {
        sizePerPage: 20,
        totalSize: transactionData.length,
        custom: true,
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{sitename}</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs title="Accounting" breadcrumbItem="End User Accounts" />
                    {/*<DateRangeCard />*/}
                    <Card>
                        <CardBody>
                            <Row>
                                <Col xs={12} sm={12} md={12} lg={6}>
                                    <Row>
                                        <Col xs={6} sm={6} md={6} lg={8}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-firstname-Input">
                                                    User Number (Enter Last Ten Digits)
                                                </Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    id="formrow-firstname-Input"
                                                    onChange={e => {
                                                        setSearchUserId(e.target.value)
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col
                                            xs={6}
                                            sm={6}
                                            md={6}
                                            lg={4}
                                            className="d-flex flex-column justify-content-end"
                                        >
                                            <div className="mb-3">
                                                <Label
                                                    htmlFor="formrow-firstname-Input"
                                                    style={{ visibility: "hidden" }}
                                                >
                                                    User Number
                                                </Label>

                                                <button
                                                    type="submit"
                                                    className="btn btn-primary w-md form-control"
                                                    onClick={() => {
                                                        getData()
                                                    }}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={6} sm={6} md={6} lg={3}></Col>

                            </Row>
                            <Row
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                }}
                            >
                                {/*<Col sm={6} md={4} lg={6}></Col>*/}
                                <Col xs={6} sm={6} md={6} lg={3}>
                                    <Row>
                                        <Col xs={6} sm={6} md={6} lg={6} >
                                            <Button className="btn btn-primary"
                                                    onClick={(event) => {
                                                        setSearchUserId("all"),
                                                            searchAll()
                                                    }}>List All</Button>
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody>
                            {
                                (loadingMessage && loadingMessage == "1") ?
                                    <TableLoader/> :
                                    <PaginationProvider
                                        pagination={paginationFactory(pageOptions)}
                                        keyField="id"
                                        columns={columns}
                                        data={data}
                                    >
                                        {({ paginationProps, paginationTableProps }) => (
                                            <ToolkitProvider
                                                keyField="id"
                                                data={data}
                                                columns={columns}
                                                bootstrap4
                                                search
                                            >
                                                {toolkitProps => (
                                                    <React.Fragment>
                                                        <Row className="mb-2">
                                                            <Col sm="4">
                                                                <div className="search-box me-2 mb-2 d-inline-block">
                                                                    <div className="position-relative">
                                                                        <SearchBar {...toolkitProps.searchProps} />
                                                                        <i className="bx bx-search-alt search-icon" />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xl="12">
                                                                <div className="table-responsive">
                                                                    <BootstrapTable
                                                                        keyField="id"
                                                                        responsive
                                                                        bordered={false}
                                                                        striped={false}
                                                                        defaultSorted={defaultSorted}
                                                                        selectRow={selectRow}
                                                                        classes={
                                                                            "table align-middle table-nowrap table-check"
                                                                        }
                                                                        headerWrapperClasses={"table-light"}
                                                                        {...toolkitProps.baseProps}
                                                                        {...paginationTableProps}
                                                                        rowClasses={"mytable-hover-row"}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <div className="pagination pagination-rounded justify-content-end">
                                                            <PaginationListStandalone {...paginationProps} />
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </ToolkitProvider>
                                        )}
                                    </PaginationProvider>
                            }


                        </CardBody>
                        {
                            (transactionData && transactionData.length!=0) ?
                                <Card>
                                    <CardBody>
                                        {
                                            (transactionLoadingMessage && transactionLoadingMessage == "1") ?
                                                <TableLoader/> :
                                                <PaginationProvider
                                                    pagination={paginationFactory(pageTransactionOptions)}
                                                    keyField="id"
                                                    columns={transactionColumns}
                                                    data={transactionData}
                                                >
                                                    {({ paginationProps, paginationTableProps }) => (
                                                        <ToolkitProvider
                                                            keyField="id"
                                                            data={transactionData}
                                                            columns={transactionColumns}
                                                            bootstrap4
                                                        >
                                                            {toolkitProps => (
                                                                <React.Fragment>
                                                                    {/*<Row className="mb-2">*/}
                                                                    {/*    <Col sm="4">*/}
                                                                    {/*        <div className="search-box me-2 mb-2 d-inline-block">*/}
                                                                    {/*            <div className="position-relative">*/}
                                                                    {/*                <SearchBar {...toolkitProps.searchProps} />*/}
                                                                    {/*                <i className="bx bx-search-alt search-icon" />*/}
                                                                    {/*            </div>*/}
                                                                    {/*        </div>*/}
                                                                    {/*    </Col>*/}
                                                                    {/*</Row>*/}
                                                                    <Row>
                                                                        <Col xl="12">
                                                                            <div className="table-responsive">
                                                                                <BootstrapTable
                                                                                    keyField="id"
                                                                                    responsive
                                                                                    bordered={false}
                                                                                    striped={false}
                                                                                    defaultSorted={defaulTransactiontSorted}
                                                                                    // selectRow={selectRow}
                                                                                    classes={
                                                                                        "table align-middle table-nowrap table-check"
                                                                                    }
                                                                                    headerWrapperClasses={"table-light"}
                                                                                    {...toolkitProps.baseProps}
                                                                                    {...paginationTableProps}
                                                                                    rowClasses={"mytable-hover-row"}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <div className="pagination pagination-rounded justify-content-end">
                                                                        <PaginationListStandalone {...paginationProps} />
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </ToolkitProvider>
                                                    )}
                                                </PaginationProvider>
                                        }
                                    </CardBody>
                                </Card>
                                :''
                        }

                    </Card>
                    {
                        (isModalOpen) ?
                            <ReasonModal
                                setModalOpen={setModalOpen}
                                isModalOpen={isModalOpen}
                                functionName={functionName}
                                saveNoteWithAmount={saveNoteWithAmount}
                                setReason = {setReason}
                                reason = {reason}
                            />
                            : ''
                    }

                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(EndUserAccounts)
